import { ReactNode } from "react";
import PageLayout from "../../components/PageLayout/PageLayout";
import { SitePage } from "../../types/SitePage";
import "./ErrorPage.scss";

interface ErrorPageProps {
  error?: Error;
  userMessage?: string;
  children?: ReactNode;
}

const ErrorPage: React.FC<ErrorPageProps> = ({
  error,
  userMessage,
  children = null,
}) => {
  return (
    <PageLayout page={SitePage.Error} title="Error">
      <div className="container error-page-layout">
        <h1>Error. Miscue.</h1>
        {userMessage && (
          <div className="alert alert-danger" role="alert">
            {userMessage}
            {error && (
              <div>
                <hr />
                <strong>More specifically:</strong> {error.message}
              </div>
            )}
          </div>
        )}
        {children}
      </div>
    </PageLayout>
  );
};

export default ErrorPage;
